import { NgModule } from '@angular/core';
import { ReportsRoutingModule } from './reports-routing.module';
import { ActiveRateCodeComponent } from './active-rate-code/active-rate-code.component';
import { HomeModule } from '../home/home.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActiveRateCodeReportComponent } from './active-rate-code-report/active-rate-code-report.component';
import { MaterialModule } from '../material/material.module';
import { PayrollReportComponent } from './payroll-report/payroll-report.component';
@NgModule({
  declarations: [
    ActiveRateCodeComponent, 
    ActiveRateCodeReportComponent, 
    PayrollReportComponent],
  imports: [
    ReportsRoutingModule,
    HomeModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ]
})
export class ReportsModule { }
